import React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import NumberFormatCustom from '../common/form/NumberFormatCustom';

// 2026-10-23 (250423 피드백 #5-a "목표 수정 안됨, 수정 아이콘을 만들던지"): 이미 저장된
// 목표가 있으면 기본적으로 읽기 전용으로 보여주고, 수정 아이콘을 눌러야 편집 모드로
// 전환되게 했다 — "저장된 값인데 그냥 입력칸처럼 보여서 수정 가능한지 알기 어렵다"는
// 고객 피드백에 대한 명시적인 UI 장치.
const YearGoalForm = ({ formik, onAutoDisHandler, editable, hasSavedData, onEditClick, onTotalFieldChange }) => {

    return (
        <Box
            component="form"
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
            noValidate
            autoComplete="off"
            onSubmit={formik.handleSubmit}
            >

            <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
                sx={{ p: 1, borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
            >
                <Grid item xs={2} align="right"><FormLabel><Typography variant="subtitle2" component="span">총목표매출</Typography><Typography variant="subtitle2" component="span" sx={{ color: 'error.main' }}>(필수)</Typography></FormLabel></Grid>
                <Grid item xs={4}>
                    <TextField
                        size="small"
                        required={true}
                        variant="outlined"
                        fullWidth
                        disabled={!editable}
                        id="ptargetSales"
                        name="ptargetSales"
                        value={formik.values.ptargetSales}
                        onChange={onTotalFieldChange}
                        error={formik.touched.ptargetSales && Boolean(formik.errors.ptargetSales)}
                        helperText={formik.touched.ptargetSales && formik.errors.ptargetSales}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                    />
                </Grid>
                <Grid item xs={2} align="right"><FormLabel><Typography variant="subtitle2" component="span">총매출이익</Typography><Typography variant="subtitle2" component="span" sx={{ color: 'error.main' }}>(필수)</Typography></FormLabel></Grid>
                <Grid item xs={3}>
                    <TextField
                        size="small"
                        required={true}
                        variant="outlined"
                        fullWidth
                        disabled={!editable}
                        id="ptargetSalesProfit"
                        name="ptargetSalesProfit"
                        value={formik.values.ptargetSalesProfit}
                        onChange={onTotalFieldChange}
                        error={formik.touched.ptargetSalesProfit && Boolean(formik.errors.ptargetSalesProfit)}
                        helperText={formik.touched.ptargetSalesProfit && formik.errors.ptargetSalesProfit}
                        InputProps={{
                            inputComponent: NumberFormatCustom,
                        }}
                    />
                </Grid>
                <Grid item xs={1} align="center">
                    {hasSavedData && !editable && (
                        <Tooltip title="목표 수정">
                            <IconButton color="primary" onClick={onEditClick} aria-label="목표 수정">
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Grid>

            </Grid>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    m: 1
                }}
            >
                {editable && (
                    <>
                        <Button
                            sx={{ mx: 1 }}
                            variant="contained"
                            onClick={() => onAutoDisHandler(formik.values.ptargetSales, formik.values.ptargetSalesProfit)}
                        >
                            자동배분
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            disabled={formik.isSubmitting}
                        >
                            저장
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    )
}

export default YearGoalForm
